import { z } from 'zod';
import { englishIqKindV2Schema, englishIqSkillV2Schema } from '../common';

const englishIqEvidenceV2Schema = z.object({
  answered: z.number().int().positive(),
  skill: englishIqSkillV2Schema,
});

export const englishIqResultV2Schema = z.object({
  assessmentVersion: z.number().int().positive(),
  cefr: z.string().min(2).max(2),
  createdAt: z.number().int().nonnegative(),
  durationMs: z.number().int().nonnegative().optional(),
  estimateLabel: z.literal('quick_estimate'),
  evidence: z.array(englishIqEvidenceV2Schema).min(1).max(3),
  itemCount: z.number().int().positive(),
  kind: englishIqKindV2Schema,
  score: z.number().int().min(60).max(150),
  shareId: z.string().min(6).max(64).nullable(),
  skill: englishIqSkillV2Schema.nullable(),
  subBand: z.string().min(2).max(5),
});

export type IEnglishIqResultV2 = z.infer<typeof englishIqResultV2Schema>;
